import { NgModule } from '@angular/core';
import { AuthModule } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: environment.identityServer.url,
        redirectUrl: `${environment.app.url}/auth-callback`,
        postLogoutRedirectUri: `${environment.app.url}/login`,
        clientId: environment.identityServer.clientId,
        scope: 'openid profile email role ariapi',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `${environment.app.url}/silent-renew.html`,
        renewTimeBeforeTokenExpiresInSeconds: 60, // Increased from 10 to avoid conflicts
        configId: 'portal-auth-config',
        startCheckSession: false, // Keep disabled to prevent session conflicts
        autoUserInfo: true,
        renewUserInfoAfterTokenRenew: true,
        maxIdTokenIatOffsetAllowedInSeconds: 21600, // 6 hours to allow for users with incorrect system time
        silentRenewTimeoutInSeconds: 20, // Add timeout for silent renewal
        useRefreshToken: false, // Use silent renewal instead of refresh tokens
        autoCleanStateAfterAuthentication: true, // Clean up state after auth
        triggerAuthorizationResultEvent: true, // Enable auth result events
      },
    }),
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
